module.exports = __webpack_public_path__ + "static/media/map_base_withPOI.b8b42120.jpg";